import { render, staticRenderFns } from "./DHWSMonitor.vue?vue&type=template&id=bcf50c36&scoped=true"
import script from "./DHWSMonitor.vue?vue&type=script&lang=js"
export * from "./DHWSMonitor.vue?vue&type=script&lang=js"
import style0 from "./DHWSMonitor.vue?vue&type=style&index=0&id=bcf50c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf50c36",
  null
  
)

export default component.exports